/* eslint-disable no-case-declarations */
import { FollowsActionTypes, FollowsActionsUnion } from './actions';
import { FollowsState } from './state';

export const followsDefaultState: FollowsState = {
  dealIds: [],
  groupFollowDealIds: [],
  dealIdsFollowInProcess: [],
  dealIdsGroupFollowInProcess: [],
  loaded: false,
  loading: false,
};

export function followsReducer(
  state = followsDefaultState,
  action: FollowsActionsUnion
): FollowsState {
  let dealIds: string[];
  let groupFollowDealIds: string[];
  let existingIndex: number;
  switch (action.type) {
    case FollowsActionTypes.Load:
      return {
        ...state,
        dealIdsFollowInProcess: [],
        dealIdsGroupFollowInProcess: [],
        loaded: state.loaded,
        loading: true,
        error: undefined,
      };

    case FollowsActionTypes.LoadSuccess:
      return {
        ...state,
        dealIds: action.payload.follows,
        dealIdsFollowInProcess: [],
        groupFollowDealIds: action.payload.groupFollows,
        dealIdsGroupFollowInProcess: [],
        loaded: true,
        loading: false,
        error: undefined,
      };

    case FollowsActionTypes.LoadFail:
      return {
        ...state,
        dealIds: [],
        groupFollowDealIds: [],
        loaded: false,
        loading: false,
        error: action.payload,
      };

    case FollowsActionTypes.Follow:
      dealIds = state.dealIds.slice(0);
      dealIds.push(action.payload);

      return {
        ...state,
        dealIds,
        dealIdsFollowInProcess: [
          ...state.dealIdsFollowInProcess,
          action.payload,
        ],
      };

    case FollowsActionTypes.FollowSuccess:
      return {
        ...state,
        dealIdsFollowInProcess: state.dealIdsFollowInProcess.filter(
          (id) => id !== action.payload.dealId
        ),
        savingError: undefined,
      };

    case FollowsActionTypes.FollowFail:
      return {
        ...state,
        dealIds: state.dealIds.filter(
          (id) => !action.payload.dealIds.includes(id)
        ),
        dealIdsFollowInProcess: state.dealIdsFollowInProcess.filter(
          (id) => !action.payload.dealIds.includes(id)
        ),
        savingError: action.payload.errorMessage,
      };

    case FollowsActionTypes.Unfollow:
      existingIndex = state.dealIds.indexOf(action.payload);
      dealIds = state.dealIds.slice(0);
      if (existingIndex > -1) {
        dealIds.splice(existingIndex, 1);
      }

      return {
        ...state,
        dealIds,
        dealIdsFollowInProcess: [
          ...state.dealIdsFollowInProcess,
          action.payload,
        ],
      };

    case FollowsActionTypes.PureUnfollow:
      existingIndex = state.dealIds.indexOf(action.payload);
      dealIds = state.dealIds.slice(0);
      if (existingIndex > -1) {
        dealIds.splice(existingIndex, 1);
      }

      return {
        ...state,
        dealIds,
      };

    case FollowsActionTypes.UnfollowSuccess:
      return {
        ...state,
        dealIdsFollowInProcess: state.dealIdsFollowInProcess.filter(
          (id) => id !== action.payload.dealId
        ),
        savingError: undefined,
      };

    case FollowsActionTypes.UnfollowFail:
      dealIds = action.payload.dealIds.reduce((deals, id) => {
        if (!deals.includes(id)) {
          deals.push(id);
        }
        return deals;
      }, state.dealIds.slice(0));
      return {
        ...state,
        dealIds,
        dealIdsFollowInProcess: state.dealIdsFollowInProcess.filter(
          (id) => !action.payload.dealIds.includes(id)
        ),
        savingError: action.payload.errorMessage,
      };

    case FollowsActionTypes.GroupFollow:
      groupFollowDealIds = state.groupFollowDealIds.slice(0);
      groupFollowDealIds.push(action.payload.dealId);

      return {
        ...state,
        groupFollowDealIds,
        dealIdsGroupFollowInProcess: [
          ...state.dealIdsGroupFollowInProcess,
          action.payload.dealId,
        ],
      };

    case FollowsActionTypes.GroupFollowSuccess:
      return {
        ...state,
        dealIdsGroupFollowInProcess: state.dealIdsGroupFollowInProcess.filter(
          (id) => id !== action.payload.dealId
        ),
        savingError: undefined,
      };

    case FollowsActionTypes.GroupFollowFail:
      existingIndex = state.groupFollowDealIds.indexOf(action.payload.dealId);
      groupFollowDealIds = state.groupFollowDealIds.slice(0);
      if (existingIndex > -1) {
        groupFollowDealIds.splice(existingIndex, 1);
      }

      return {
        ...state,
        groupFollowDealIds,
        dealIdsGroupFollowInProcess: state.dealIdsGroupFollowInProcess.filter(
          (id) => id !== action.payload.dealId
        ),
        savingError: action.payload.errorMessage,
      };

    case FollowsActionTypes.GroupUnfollow:
      existingIndex = state.groupFollowDealIds.indexOf(action.payload);
      groupFollowDealIds = state.groupFollowDealIds.slice(0);
      if (existingIndex > -1) {
        groupFollowDealIds.splice(existingIndex, 1);
      }

      return {
        ...state,
        groupFollowDealIds,
        dealIdsGroupFollowInProcess: [
          ...state.dealIdsGroupFollowInProcess,
          action.payload,
        ],
      };

    case FollowsActionTypes.GroupUnfollowSuccess:
      return {
        ...state,
        dealIdsGroupFollowInProcess: state.dealIdsGroupFollowInProcess.filter(
          (id) => id !== action.payload.dealId
        ),
        savingError: undefined,
      };

    case FollowsActionTypes.GroupUnfollowFail:
      groupFollowDealIds = state.groupFollowDealIds.slice(0);
      if (!groupFollowDealIds.includes(action.payload.dealId))
        groupFollowDealIds.push(action.payload.dealId);

      return {
        ...state,
        groupFollowDealIds,
        dealIdsGroupFollowInProcess: state.dealIdsGroupFollowInProcess.filter(
          (id) => id !== action.payload.dealId
        ),
        savingError: action.payload.errorMessage,
      };

    case FollowsActionTypes.GroupFollowUpdate:
      const update =
        !!state.groupFollowDealIds &&
        state.groupFollowDealIds.indexOf(action.payload) === -1
          ? [...state.groupFollowDealIds, action.payload]
          : state.groupFollowDealIds;
      return {
        ...state,
        groupFollowDealIds: update,
      };

    case FollowsActionTypes.GroupUnfollowUpdate:
      const groupFollowDealIdsUpdate =
        !!state.groupFollowDealIds &&
        state.groupFollowDealIds.indexOf(action.payload) > -1
          ? state.groupFollowDealIds.filter((el) => el !== action.payload)
          : state.groupFollowDealIds;
      return {
        ...state,
        groupFollowDealIds: groupFollowDealIdsUpdate,
      };

    case FollowsActionTypes.UnfollowMultiple:
    case FollowsActionTypes.FollowMultiple:
      return {
        ...state,
        dealIdsFollowInProcess: [
          ...state.dealIdsFollowInProcess,
          ...action.payload,
        ],
      };

    case FollowsActionTypes.FollowMultipleToggleSuccess:
      return {
        ...state,
        dealIds: action.payload.deals,
        dealIdsFollowInProcess: state.dealIdsFollowInProcess.filter(
          (id) => !action.payload.dealIdsFollowInProcess.includes(id)
        ),
        savingError: undefined,
      };

    default:
      return state;
  }
}

export const selectFollows = (followsState: FollowsState): string[] =>
  followsState.dealIds;
export const selectGroupFollows = (followsState: FollowsState): string[] =>
  followsState.groupFollowDealIds;

export const selectDealsFollowInProcess = (
  followsState: FollowsState
): string[] => followsState.dealIdsFollowInProcess;

export const selectDealsGroupFollowInProcess = (
  followsState: FollowsState
): string[] => followsState.dealIdsGroupFollowInProcess;
